import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Subscribes to realtime changes on public.services and invalidates the
 * provided React Query keys whenever a service is created, updated or deleted.
 *
 * Used so that newly registered/edited/removed services appear instantly on
 * every open booking screen, without requiring a page refresh.
 */
export function useServicesRealtime(invalidateKeys: string[] = ['services']) {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel(`services-changes-${Math.random().toString(36).slice(2)}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'services' },
        () => {
          invalidateKeys.forEach((key) => {
            queryClient.invalidateQueries({ queryKey: [key] });
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
